import React, { useEffect, useState } from 'react';
import { ModalBase } from '@panel/commons';
import PerformanceTips from '@panel/commons/lib/Modals/PerformanceTips';
import PrintModal from '@panel/commons/lib/Modals/PrintModal';
import ReportsModal from '@panel/commons/lib/Modals/ReportsModal';
import EndModal from '@panel/commons/lib/Modals/EndModal';
import UnreadLeadsModal from '@panel/commons/lib/Modals/UnreadLeadsModal';
import { sendTrackingInfo, sendCustomTrackingInfo } from '@panel/commons/lib/sendTrackingInfo';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { DesempenoSelectors, DesempenoOperations } from '../../ducks/desempeno';
import UpgradePlanModal from '../Modals/UpgradePlanModal';
import IntegratorModal from '../Modals/IntegratorModal';
import { Modal } from './ModalWrapper';

const ModalsArea = ({
  device,
  showModal,
  setShowModal,
  posting,
  postingQuality,
  redirectToEdit,
  postingId,
  isReserved,
  isIntegrator,
  publisherTypeId,
  setFinishedAction,
  isAssistant,
  finishReason,
  loadingFinishReason,
  publisherId
}) => {
  const { performanceTips, reportsModal, upgrade, editIntegrator, printModal, endModal } = showModal;
  const { isDuplicate } = posting;
  const validations = postingQuality && postingQuality.validations;
  const postingToUnreadLeadsModalFormat = {
    postingId,
    publisherId: posting.publisher_id
  };
  const dispatch = useDispatch();
  const {
    postingReports,
    loadingCredits,
    recievedSuccessfulResponse,
    loadingSuspendPosting,
    showUnreadLeadsModal,
    sendUnreadLeadsMsgLoading,
    hasUnreadLeadsLoading,
    hasUnreadLeads
  } = useSelector(DesempenoSelectors.getDesempenoState);
  const { fetchReports, checkReport, savePostingTag, getUnreadLeads } = DesempenoOperations;
  const [enableUnreadLeadsModal, setEnableUnreadLeadsModal] = useState(false);

  const hasUncheckedReports = () => {
    if (!postingReports) return;
    const { reports } = postingReports;
    if (!reports) return;
    // eslint-disable-next-line consistent-return
    return reports.some(rep => rep.unChecked);
  };

  const { t } = useTranslation();

  const handlePrintCTA = () => {
    sendTrackingInfo('Panel', 'Mis avisos', 'Desempeño del aviso-Imprimir-Notificar');
    setFinishedAction({
      postingId: '',
      action: 'print',
      result: 'SUCCESS',
      component: t('panel.avisos.print.snackbar.SUCCESS'),
      keepOpen: false
    });
  };
  useEffect(() => {
    if (showUnreadLeadsModal && recievedSuccessfulResponse) {
      setEnableUnreadLeadsModal(showUnreadLeadsModal);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showUnreadLeadsModal, recievedSuccessfulResponse]);

  useEffect(() => {
    // Se consume servicio para validar si el aviso tiene consultas sin responder:
    if (endModal) {
      dispatch(getUnreadLeads(postingId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endModal]);

  return (
    <>
      {performanceTips && (
        <Modal>
          <ModalBase
            openModal={performanceTips}
            onClose={() => setShowModal({ ...showModal, performanceTips: false })}
            width={device !== 'mobile' ? '400px' : '95%'}
            // eslint-disable-next-line no-nested-ternary
            height={isAssistant ? '330px' : device === 'mobile' ? 'fit-content' : '400px'}
          >
            <PerformanceTips
              device={device}
              datalayerText='Desempeño del aviso-Mejora tu calidad_Ir a editar el aviso'
              tips={validations || []}
              postingId={postingId}
              isDuplicate={isDuplicate}
              isIntegrator={isIntegrator}
              isAssistant={isAssistant}
              publisherTypeId={publisherTypeId}
              publicationType={posting.publicationType}
            />
          </ModalBase>
        </Modal>
      )}
      {reportsModal && (
        <Modal>
          <ModalBase
            openModal={reportsModal}
            onClose={() => setShowModal({ ...showModal, reportsModal: false })}
            width={device !== 'mobile' ? '443px' : '90%'}
            height='fit-content'
          >
            <ReportsModal
              onClose={() => setShowModal({ ...showModal, reportsModal: false })}
              device={device}
              isReserved={isReserved}
              postingReports={postingReports}
              redirectToEdit={redirectToEdit}
              isIntegrator={isIntegrator}
              hasReportsUnchecked={hasUncheckedReports()}
              checkReport={() => dispatch(checkReport(postingId))}
              fetchReports={() => dispatch(fetchReports(postingId))}
              savePostingTag={() => dispatch(savePostingTag(postingId, 1))}
              isAssistant={isAssistant}
            />
          </ModalBase>
        </Modal>
      )}
      {upgrade && (
        <Modal>
          <ModalBase
            openModal={upgrade}
            onClose={() => setShowModal({ ...showModal, upgrade: false })}
            width={device !== 'mobile' ? '400px' : '90%'}
            height='fit-content'
            isLoading={loadingCredits}
          >
            <UpgradePlanModal
              onClose={() => setShowModal({ ...showModal, upgrade: false })}
              posting={posting}
              publicationType={posting.publicationType}
              // se coloca por defecto el tipo de operacion venta: 1
              operationType={
                posting.price_operationtype[0] ? posting.price_operationtype[0].amountAndCurrency.operationType : 1
              }
              device={device}
              postingId={postingId}
              isIntegrator={isIntegrator}
              publisherId={posting.publisher_id}
              publisherTypeId={publisherTypeId}
            />
          </ModalBase>
        </Modal>
      )}
      {editIntegrator && (
        <Modal>
          <ModalBase
            openModal={editIntegrator}
            onClose={() => setShowModal({ ...showModal, editIntegrator: false })}
            width={device !== 'mobile' ? '400px' : '90%'}
            height='fit-content'
          >
            <IntegratorModal
              onClose={() => setShowModal({ ...showModal, editIntegrator: false })}
              redirectToEdit={redirectToEdit}
              device={device}
            />
          </ModalBase>
        </Modal>
      )}
      {printModal && (
        <Modal>
          <ModalBase
            openModal={printModal}
            onClose={() => setShowModal({ ...showModal, printModal: false })}
            width={device !== 'mobile' ? '400px' : '90%'}
            height='450px'
          >
            <PrintModal onClose={() => setShowModal({ ...showModal, printModal: false })} handleCTA={handlePrintCTA} />
          </ModalBase>
        </Modal>
      )}
      {endModal && (
        <Modal>
          <ModalBase
            openModal={endModal}
            onClose={() => {
              setShowModal({ ...showModal, endModal: false });
              sendCustomTrackingInfo({
                event: 'trackEvent',
                eventCategory: 'Panel',
                eventAction: 'Mis avisos',
                eventLabel: 'Finalizar Aviso-finalizar_cerrar'
              });
            }}
            isLoading={
              loadingFinishReason || recievedSuccessfulResponse || loadingSuspendPosting || hasUnreadLeadsLoading
            }
            withoutOutsideClose
          >
            <EndModal
              device={device}
              onClose={() => setShowModal({ ...showModal, endModal: false })}
              postingId={postingId}
              publisherTypeId={publisherTypeId}
              finishReason={finishReason}
              publisherId={publisherId}
              SuspendOperations={DesempenoOperations}
              UnreadLeadsMsgOperations={DesempenoOperations}
              hasUnreadLeads={hasUnreadLeads}
            />
          </ModalBase>
        </Modal>
      )}
      {enableUnreadLeadsModal && (
        <Modal>
          <ModalBase
            openModal={enableUnreadLeadsModal}
            onClose={() => {
              dispatch(DesempenoOperations.setShowUnreadLeadsModal(false));
              setEnableUnreadLeadsModal(false);
              sendCustomTrackingInfo({
                event: 'trackEvent',
                eventCategory: 'Panel',
                eventAction: 'Mis avisos',
                eventLabel: 'Finalizar Aviso-enviar_cerrar'
              });
            }}
            isLoading={sendUnreadLeadsMsgLoading}
            withoutOutsideClose
          >
            <UnreadLeadsModal
              onClose={() => {
                dispatch(DesempenoOperations.setShowUnreadLeadsModal(false));
                setEnableUnreadLeadsModal(false);
              }}
              publisherTypeId={publisherTypeId}
              publisherId={publisherId}
              UnreadLeadsMsgOperations={DesempenoOperations.sendUnreadLeadsMessagge}
              UnreadLeadsMsgSelectors={DesempenoSelectors.getDesempenoState}
              postings={[postingToUnreadLeadsModalFormat]}
            />
          </ModalBase>
        </Modal>
      )}
    </>
  );
};

export default ModalsArea;
